import * as S from './Styled';
import Icon from '../../Icon';
import Spinner from '../../Spinner';
import CityPopover from '../../CityPopover';
import { setLocationConfirmed } from '../../../actions';
import { Cities } from '../modals';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

export default ({
  location,
  isLoading,
  locationConfirmed,
  onChangeCity,
  onSelectCity,
}) => {
  const [cities, setCities] = useState(false);
  const [popover, setPopover] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <>
      <S.LocationLink
        to=""
        onClick={event => {
          event.preventDefault();
          setPopover(true);
        }}
      >
        <Icon name="location" size="small" />
        <S.City>
          {isLoading ? (
            <Spinner />
          ) : location ? (
            location.name
          ) : (
            t('labels.not_defined')
          )}
        </S.City>
      </S.LocationLink>

      <CityPopover
        onChangeCity={event => {
          onChangeCity(event);
          setPopover(false);
          setCities(true);
        }}
        confirmLocation={() => dispatch(setLocationConfirmed(true))}
        location={location}
        locationConfirmed={locationConfirmed}
        _popover={[popover, setPopover]}
      />

      <Cities
        isLoading={isLoading}
        visible={cities}
        onOk={value => {
          onSelectCity(value);
          setCities(false);
          setPopover(false);
        }}
        onCancel={() => {
          if (!isLoading) {
            setCities(false);
          }
        }}
        location={location}
      />
    </>
  );
};
